import React from "react";

import LandingHeader from "../header";

import "./aboutus.css";
import Footer from "../footer";

function AboutUs() {
  return (
    <div className="about-us-wrapper">

      {/* Website Header */}
      <div className="about-us-header">
        <LandingHeader />
      </div>


      {/* Hero */}
      <div className="about-us-hero">

        <div className="about-us-hero-title">
          About Us
        </div>

        <div className="about-us-hero-subtitle">
          Building simpler, smarter and more efficient recruitment
          experiences.
        </div>

      </div>


      {/* About Company */}
      <div className="about-us-content">

        <section className="about-us-section">

          <h2>
            About <span className="text-blue">HMW Communications</span>
          </h2>

          <p>
            HMW Communications Private Limited is a technology and
            services company focused on helping organizations and
            professionals connect through modern recruitment and
            workforce technology.
          </p>

          <p>
            Our goal is to simplify the recruitment process by combining
            technology, automation, artificial intelligence, and
            human expertise.
          </p>

          <p>
            We build technology that helps organizations manage their
            hiring processes while making it easier for candidates to
            discover and apply for relevant career opportunities.
          </p>

        </section>


        {/* Products */}
        <section className="about-us-section">

          <h2>
            Our <span className="text-blue">Platforms</span>
          </h2>


          <div className="about-us-product-wrapper">

            <div className="about-us-product-card">

              <h3>QuallyHire AI</h3>

              <p>
                QuallyHire AI is an AI-powered hiring and recruitment
                platform designed for employers, recruiters, staffing
                organizations, and recruitment teams.
              </p>

              <p>
                It helps organizations manage recruitment workflows,
                job requirements, candidates, resumes, applications,
                evaluations, and other hiring activities through a
                centralized platform.
              </p>

              <div className="about-us-product-link">
                <a href="/home">
                  Explore QuallyHire AI
                </a>
              </div>

            </div>


            <div className="about-us-product-card">

              <h3>NuJobs</h3>

              <p>
                NuJobs is our job discovery and recruitment platform
                built for candidates and organizations.
              </p>

              <p>
                Candidates can discover job opportunities, create
                profiles, manage resumes, save jobs, and apply for
                positions through the platform.
              </p>

              <div className="about-us-product-link">
                <a href="/nujobs">
                  Explore NuJobs
                </a>
              </div>

            </div>

          </div>

        </section>


        {/* What We Believe */}
        <section className="about-us-section">

          <h2>
            What We <span className="text-blue">Believe</span>
          </h2>

          <div className="about-us-beliefs">

            <div className="about-us-belief-card">
              <h3>Technology Should Simplify</h3>

              <p>
                Recruitment involves many steps and stakeholders.
                We believe technology should simplify these processes
                rather than make them more complicated.
              </p>
            </div>


            <div className="about-us-belief-card">
              <h3>Automation Saves Time</h3>

              <p>
                Repetitive recruitment activities can consume valuable
                time. Automation can help recruitment teams focus more
                on people and decisions that matter.
              </p>
            </div>


            <div className="about-us-belief-card">
              <h3>People Make the Decisions</h3>

              <p>
                AI and automation can assist recruitment teams, but
                important hiring decisions should remain with the
                appropriate people and organizations.
              </p>
            </div>

          </div>

        </section>


        {/* Our Vision */}
        <section className="about-us-section about-us-vision">

          <h2>
            Our <span className="text-blue">Vision</span>
          </h2>

          <p>
            We envision a recruitment ecosystem where organizations
            can find talent more efficiently and candidates can discover
            meaningful career opportunities with less friction.
          </p>

          <p>
            Through QuallyHire AI and NuJobs, we are building technology
            that connects the different sides of the recruitment
            ecosystem while keeping the experience simple and
            accessible.
          </p>

        </section>


        {/* Contact */}
        <section className="about-us-section">

          <h2>
            Get in <span className="text-blue">Touch</span>
          </h2>

          <p>
            Whether you are an organization looking to improve your
            recruitment process, a recruiter looking for better hiring
            technology, or a candidate looking for your next
            opportunity, we would be happy to hear from you.
          </p>

          <div className="about-us-contact">

            <strong>
              HMW Communications Private Limited
            </strong>

            <br />

            Email: support@hmwcomm.com

          </div>

        </section>

      </div>


      {/* Footer */}
      <Footer />

    </div>
  );
}

export default AboutUs;